import React, { Component } from "react";
import axios from "axios";
import { getErrorsMessage } from "../utils.js";
import SimplePagination from "./SimplePagination";

const today = () => {
    const date = new Date();
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

const addDay = date => {
    const value = new Date(`${date}T00:00:00Z`);
    value.setUTCDate(value.getUTCDate() + 1);
    return value.toISOString().slice(0, 10);
};

class TemplateDocumentRequestModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            documents: [],
            expedients: [],
            documentIds: [],
            personProviderIds: [],
            scheduledFor: today(),
            minDate: today(),
            sendNotification: true,
            scope: 'all',
            search: '',
            expedientSearch: '',
            expedientPage: 1,
            expedientTotal: 0,
            totalExpedients: 0,
            loadingExpedients: false,
            immediate: false,
            loading: false,
            step: 1,
        };
    }

    componentDidUpdate(previousProps, previousState) {
        if (this.state.step !== 3) {
            this.destroyDatePicker();
            return;
        }
        const localDate = value => {
            const [year, month, day] = value.split('-').map(Number);
            return new Date(year, month - 1, day);
        };
        if (!this.datePicker) {
            this.datePicker = $(this.dateInput).datepicker({
                format: 'dd/mm/yyyy', startDate: localDate(addDay(this.state.minDate)),
                autoclose: true, todayHighlight: true, container: '#templateDocumentRequestModal',
            }).on('changeDate', event => {
                const date = event.date;
                const scheduledFor = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : '';
                if (scheduledFor !== this.state.scheduledFor) this.setState({ scheduledFor });
            });
            this.datePicker.datepicker('setDate', localDate(this.state.scheduledFor));
        } else if (previousState.scheduledFor !== this.state.scheduledFor) {
            this.datePicker.datepicker('setDate', this.state.scheduledFor ? localDate(this.state.scheduledFor) : null);
        }
    }

    destroyDatePicker() {
        if (this.datePicker) {
            this.datePicker.off('changeDate').datepicker('destroy');
            this.datePicker = null;
        }
    }

    componentWillUnmount() {
        this.destroyDatePicker();
    }

    open = async () => {
        this.expedientRequestId = (this.expedientRequestId || 0) + 1;
        this.setState({ loading: true });
        try {
            const response = await axios.get(`/api/dossiers/${this.props.dossierId}/document-request-options`);
            this.setState({
                documents: response.data.documents,
                expedients: response.data.expedients.data,
                expedientPage: response.data.expedients.current_page,
                expedientTotal: response.data.expedients.total,
                totalExpedients: response.data.expedients.total,
                loadingExpedients: false,
                documentIds: [],
                personProviderIds: [],
                scheduledFor: addDay(response.data.today),
                minDate: response.data.today,
                sendNotification: true,
                scope: 'all',
                search: '',
                expedientSearch: '',
                immediate: false,
                step: 1,
            });
            $('#templateDocumentRequestModal').modal('show');
        } catch (error) {
            swal.fire({ text: getErrorsMessage(error), icon: 'error', confirmButtonText: 'Aceptar' });
        } finally {
            this.setState({ loading: false });
        }
    };

    toggle = (key, id) => {
        this.setState(state => ({
            [key]: state[key].includes(id)
                ? state[key].filter(item => item !== id)
                : [...state[key], id],
        }));
    };

    openForDocuments = async (documents) => {
        this.setState({ loading: true });
        try {
            const response = this.props.onConfigureDocuments ? null : await axios.get(`/api/dossiers/${this.props.personProviderId}/scheduled-document-requests`);
            const serverToday = response ? response.headers['x-request-date'] : today();
            this.setState({
                documents,
                documentIds: documents.map(document => document.id),
                scheduledFor: addDay(serverToday),
                minDate: serverToday,
                sendNotification: true,
                immediate: false,
                step: 2,
            });
            $('#templateDocumentRequestModal').modal('show');
        } catch (error) {
            swal.fire({ text: getErrorsMessage(error), icon: 'error', confirmButtonText: 'Aceptar' });
        } finally {
            this.setState({ loading: false });
        }
    };

    loadExpedients = async (page = 1, search = this.state.expedientSearch) => {
        const requestId = this.expedientRequestId = (this.expedientRequestId || 0) + 1;
        this.setState({ loadingExpedients: true, expedientSearch: search });
        try {
            const response = await axios.get(`/api/dossiers/${this.props.dossierId}/document-request-options`, {
                params: { page, search },
            });
            if (requestId !== this.expedientRequestId) return;
            this.setState({
                expedients: response.data.expedients.data,
                expedientPage: response.data.expedients.current_page,
                expedientTotal: response.data.expedients.total,
            });
        } catch (error) {
            if (requestId === this.expedientRequestId) {
                swal.fire({ text: getErrorsMessage(error), icon: 'error', confirmButtonText: 'Aceptar' });
            }
        } finally {
            if (requestId === this.expedientRequestId) this.setState({ loadingExpedients: false });
        }
    };

    submit = async (event) => {
        event.preventDefault();
        const { documentIds, personProviderIds, scheduledFor, sendNotification, scope, immediate } = this.state;
        this.setState({ loading: true });

        try {
            if (this.props.onConfigureDocuments) {
                this.props.onConfigureDocuments({
                    documents: this.state.documents,
                    scheduledFor: immediate ? null : scheduledFor,
                    sendNotification,
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                });
                $('#templateDocumentRequestModal').modal('hide');
                return;
            }
            if (this.props.personProviderId && immediate) {
                await this.props.onImmediate();
                $('#templateDocumentRequestModal').modal('hide');
                return;
            }
            const url = this.props.personProviderId
                ? `/api/dossiers/${this.props.personProviderId}/scheduled-document-requests`
                : `/api/dossiers/${this.props.dossierId}/document-requests`;
            const response = await axios.post(url, {
                document_ids: documentIds,
                template_only: !this.props.personProviderId && !this.props.onConfigureDocuments && this.state.totalExpedients === 0,
                person_provider_ids: personProviderIds,
                scheduled_for: immediate ? this.state.minDate : scheduledFor,
                send_notification_to_provider: immediate ? true : sendNotification,
                scope: scope,
            });
            $('#templateDocumentRequestModal').modal('hide');
            const action = response.data.scheduled ? 'programaron' : 'solicitaron';
            await swal.fire({
                text: response.data.template_only
                    ? 'Se agregaron los documentos a la plantilla de expediente.'
                    : `Se ${action} ${response.data.requests} documento(s) en ${response.data.expedients} expediente(s).`,
                icon: 'success',
                confirmButtonText: 'Aceptar',
            });
            if (this.props.personProviderId || response.data.template_only) location.reload();
        } catch (error) {
            swal.fire({ text: getErrorsMessage(error), icon: 'error', confirmButtonText: 'Aceptar' });
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const {
            documents, expedients, documentIds, personProviderIds, scheduledFor,
            minDate, sendNotification, scope, search, expedientSearch, immediate, loading, step,
            expedientPage, expedientTotal, totalExpedients, loadingExpedients,
        } = this.state;
        const filteredDocuments = documents.filter(document =>
            document.title.toLowerCase().includes(search.toLowerCase())
        );
        const canSubmit = documentIds.length > 0 && totalExpedients > 0 &&
            (scope === 'all' || personProviderIds.length > 0) &&
            (immediate || scheduledFor >= addDay(minDate)) && !loading && !loadingExpedients;
        const templateOnly = !this.props.personProviderId && !this.props.onConfigureDocuments && totalExpedients === 0;

        return (
            <div className="modal fade" id="templateDocumentRequestModal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content bg-light">
                        <div className="modal-header border-0 px-5 px-md-15 pt-10 pb-0">
                            <div>
                                <h5 className="modal-title text-dark-75 font-weight-bolder font-size-h4">{step === 3 ? 'Programar solicitud' : step === 4 ? 'Seleccionar expedientes' : 'Solicitar documentos'}</h5>
                                {step === 1 && <p className="text-muted font-weight-bold mt-3 mb-0">{templateOnly ? 'Selecciona los documentos que vas a agregar a la plantilla.' : 'Selecciona los documentos que vas a solicitar.'}</p>}
                                {step === 3 && <p className="text-muted font-weight-bold mt-3 mb-0">Define la fecha en que el sistema generará automáticamente la solicitud.</p>}
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Cerrar">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body px-5 px-md-15 py-10">
                            {step === 1 && (
                                <>
                                    <div className="bg-white rounded p-5 p-md-8">
                                        <div className="row align-items-start mb-8">
                                            <div className="col-md-7 mb-4 mb-md-0">
                                                <h6 className="text-dark-75 font-weight-bolder font-size-lg mb-3">Tipos de documentos</h6>
                                                <span className="text-muted font-weight-bold font-size-sm">{documents.length} documentos disponibles</span>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="input-icon">
                                                <input type="search" className="form-control" placeholder="Buscar documentos" aria-label="Buscar documentos"
                                                    value={search} onChange={event => this.setState({ search: event.target.value })} />
                                                <span><i className="flaticon2-search-1 text-primary icon-md"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    <div className="overflow-auto" style={{ maxHeight: 420 }}>
                                        {filteredDocuments.map(document => (
                                            <label key={document.id} className="checkbox checkbox-lg checkbox-square checkbox-primary d-flex align-items-center py-5 mb-0">
                                                <input
                                                    type="checkbox"
                                                    checked={documentIds.includes(document.id)}
                                                    onChange={() => this.toggle('documentIds', document.id)}
                                                />
                                                <span className="mr-5 flex-shrink-0"></span>
                                                <i className="flaticon2-files-and-folders text-primary icon-lg mr-5"></i>
                                                <div className="text-break">
                                                    <div className="text-dark-75 font-weight-bolder">{document.title}</div>
                                                    <div className="text-muted font-weight-bold font-size-sm mt-2">{document.frequency === 'once' ? 'Único' : 'Recurrente'}</div>
                                                </div>
                                            </label>
                                        ))}
                                        {!filteredDocuments.length && <div className="p-4 text-muted">No hay documentos disponibles.</div>}
                                    </div>
                                    </div>
                                </>
                            )}

                            {step === 2 && (
                                <div className="bg-white rounded py-15 px-5 text-center">
                                    <i className="far fa-question-circle icon-5x text-muted mb-10" aria-hidden="true"></i>
                                    <h4 className="text-dark-75 font-weight-bold font-size-h4 mb-10">{this.props.onConfigureDocuments
                                        ? '¿Quieres agregar los documentos al aceptar la invitación o programarlos para una fecha en particular?'
                                        : '¿Quieres solicitar los documentos ahora o los quieres programar para una fecha en particular?'}</h4>
                                    <div className="d-flex flex-column flex-md-row justify-content-center">
                                        <button
                                            type="button"
                                            className="btn btn-primary font-weight-bold px-10 py-4 mx-md-3 mb-4 mb-md-0 order-md-2"
                                            disabled={loading}
                                            onClick={event => this.setState({ immediate: true }, () => {
                                                if (this.props.personProviderId || this.props.onConfigureDocuments) this.submit(event);
                                                else this.setState({ step: 4 });
                                            })}
                                        >
                                            <i className="flaticon2-send-1 mr-2"></i>
                                            {this.props.onConfigureDocuments ? 'Agregar al aceptar' : 'Solicitar ahora'}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary font-weight-bold px-10 py-4 mx-md-3 order-md-1"
                                            disabled={loading}
                                            onClick={() => this.setState({ immediate: false, step: 3 })}
                                        >
                                            <i className="flaticon2-calendar-9 mr-2"></i>
                                            Programar solicitud
                                        </button>
                                    </div>
                                </div>
                            )}

                            {step === 3 && (
                                <>
                                    <div className="bg-white rounded p-5 p-md-8 mb-8">
                                        <div className="row align-items-center">
                                            <div className="col-md-4 mb-3 mb-md-0">
                                                <label htmlFor="templateRequestDate" className="text-dark font-weight-bolder font-size-lg mb-0">Fecha de programación</label>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="input-icon input-icon-right">
                                            <input
                                                id="templateRequestDate"
                                                type="text"
                                                className="form-control text-muted"
                                                readOnly
                                                ref={input => { this.dateInput = input; }}
                                            />
                                                    <span><i className="flaticon2-calendar-9 text-primary icon-md"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-warning font-size-sm mt-3 mb-10"><i className="flaticon2-information text-warning icon-sm mr-2"></i>Solo se permiten fechas futuras a partir de mañana.</div>
                                        <h6 className="text-dark font-weight-bold font-size-lg mb-6">Se generarán las solicitudes de los siguientes documentos</h6>
                                        <div className="table-responsive overflow-auto" style={{ maxHeight: 300 }}>
                                            <table className="table table-borderless table-vertical-center mb-0">
                                                <thead><tr className="text-dark-75"><th className="pl-5">Nombre del documento</th><th>Frecuencia</th></tr></thead>
                                                <tbody>
                                                    {documents.filter(document => documentIds.includes(document.id)).map(document => (
                                                        <tr key={document.id}><td className="pl-5 py-5 text-dark-75 font-weight-bold">{document.title}</td><td className="text-muted font-weight-bold">{document.frequency === 'once' ? 'Único' : 'Recurrente'}</td></tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="bg-white rounded p-5 p-md-6">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <label htmlFor="templateRequestNotification" className="text-dark font-weight-bolder font-size-lg mb-0"><i className="flaticon2-mail text-dark-75 icon-md mr-3"></i>Notificación por correo</label>
                                            <span className="switch switch-icon switch-primary">
                                                <label className="mb-0">
                                                <input
                                                    id="templateRequestNotification"
                                                    type="checkbox"
                                                    checked={sendNotification}
                                                    onChange={event => this.setState({ sendNotification: event.target.checked })}
                                                />
                                                <span></span>
                                                </label>
                                            </span>
                                        </div>
                                        <p className="text-dark-75 font-weight-bold mb-0">Se enviará un aviso al completador cuando se genere la solicitud.</p>
                                    </div>
                                </>
                            )}
                            {step === 4 && (
                                <>
                                    <div className="text-muted mb-6">
                                        {documentIds.length} documento(s) · {immediate ? 'Solicitar ahora' : `Programar para ${scheduledFor}`}
                                    </div>
                                    <div className="radio-inline mb-8">
                                        <label className="radio radio-primary font-weight-bold">
                                            <input type="radio" name="templateRequestScope" checked={scope === 'all'} onChange={() => { this.setState({ scope: 'all' }); this.loadExpedients(1, ''); }} />
                                            <span></span>Todos ({totalExpedients})
                                        </label>
                                        <label className="radio radio-primary font-weight-bold">
                                            <input type="radio" name="templateRequestScope" checked={scope === 'selected'} onChange={() => this.setState({ scope: 'selected' })} />
                                            <span></span>Sólo algunos
                                        </label>
                                    </div>

                                    <div className="bg-white rounded p-5 p-md-8">
                                        <div className="row mb-8">
                                            <div className="col-md-7 mb-4 mb-md-0">
                                                <h6 className="text-dark-75 font-weight-bolder font-size-lg mb-3">Expedientes de invitados</h6>
                                                <div className="text-muted font-weight-bold font-size-sm">{scope === 'all' ? totalExpedients : personProviderIds.length} expediente(s) seleccionado(s)</div>
                                            </div>
                                            {scope === 'selected' && <div className="col-md-5">
                                                <div className="input-icon">
                                                <input type="search" className="form-control" placeholder="Buscar expedientes" aria-label="Buscar expedientes"
                                                    value={expedientSearch} onChange={event => this.loadExpedients(1, event.target.value)} />
                                                <span><i className="flaticon2-search-1 text-primary icon-md"></i></span>
                                                </div>
                                            </div>}
                                        </div>
                                    <div className="overflow-auto" style={{ maxHeight: 360 }}>
                                            {!loadingExpedients && expedients.map(expedient => (
                                                <label key={expedient.id} className="checkbox checkbox-lg checkbox-square checkbox-primary d-flex align-items-center py-5 mb-0">
                                                    <input
                                                        type="checkbox"
                                                        checked={scope === 'all' || personProviderIds.includes(expedient.id)}
                                                        disabled={scope === 'all'}
                                                        onChange={() => this.toggle('personProviderIds', expedient.id)}
                                                    />
                                                    <span className="mr-5 flex-shrink-0"></span>
                                                    <div className="symbol symbol-40 mr-5 flex-shrink-0">
                                                        <span className={`symbol-label text-white font-weight-bolder bg-${({1: 'danger', 2: 'success', 3: 'info', 4: 'warning'})[expedient.dossier?.dossier_type_id] || 'primary'}`}>
                                                            {expedient.dossier?.target?.name?.[0] || 'E'}
                                                        </span>
                                                    </div>
                                                    <div className="text-break">
                                                        <div className="text-dark-75 font-weight-bolder font-size-lg">
                                                            {expedient.provider?.fiscal_name || expedient.provider?.name || 'Expediente'}
                                                        </div>
                                                        <div className="text-dark-50 font-weight-bold mb-2">{expedient.dossier?.title}</div>
                                                        {expedient.dossier_status && <div className="text-muted font-weight-bold font-size-sm"><span className={`badge badge-${expedient.dossier_status.name.toLowerCase()}`}>{expedient.dossier_status.name}</span></div>}
                                                    </div>
                                                </label>
                                            ))}
                                            {loadingExpedients && <div className="p-4 text-muted" role="status">Cargando expedientes...</div>}
                                            {!loadingExpedients && !totalExpedients && <div className="p-4 text-muted">Esta plantilla no tiene expedientes activos.</div>}
                                            {!loadingExpedients && totalExpedients > 0 && !expedients.length && <div className="p-4 text-muted">No hay expedientes que coincidan con la búsqueda.</div>}
                                    </div>
                                        {expedientTotal > 5 && <div className="mt-5">
                                            <SimplePagination currentPage={expedientPage} totalFiles={expedientTotal} split={5}
                                                updateCurrentPage={page => this.loadExpedients(page)} />
                                        </div>}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer border-0 px-5 px-md-15 pt-0 pb-10">
                            <button type="button" className="btn btn-secondary font-weight-bold px-8" data-dismiss="modal">Cancelar</button>
                            {step > (this.props.personProviderId || this.props.onConfigureDocuments ? 2 : 1) && (
                                <button type="button" className="btn btn-light-primary font-weight-bold px-8" disabled={loading} onClick={() => this.setState({ step: step === 4 && immediate ? 2 : step - 1 })}>
                                    Atrás
                                </button>
                            )}
                            {step === 1 && (
                                <button type="button" className="btn btn-primary font-weight-bold px-8" disabled={!documentIds.length || loading} onClick={event => templateOnly ? this.submit(event) : this.setState({ step: 2 })}>
                                    {templateOnly ? (loading ? 'Agregando...' : 'Agregar') : 'Continuar'}
                                </button>
                            )}
                            {step === 3 && (
                                <button type="button" className="btn btn-primary font-weight-bold px-8" disabled={loading || !documentIds.length || scheduledFor < addDay(minDate)} onClick={event => this.props.personProviderId || this.props.onConfigureDocuments ? this.submit(event) : this.setState({ step: 4 })}>
                                    {this.props.personProviderId || this.props.onConfigureDocuments ? (loading ? 'Guardando...' : 'Programar solicitud') : 'Continuar'}
                                </button>
                            )}
                            {step === 4 && (
                                <button type="button" className="btn btn-primary font-weight-bold px-8" disabled={!canSubmit} onClick={this.submit}>
                                    {loading ? 'Guardando...' : immediate ? 'Solicitar ahora' : 'Programar solicitud'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TemplateDocumentRequestModal;
